<template>
  <el-dialog
    title="手工放行"
    width="1400px"
    :visible.sync="visible"
    @close="handleClose"
  >
    <el-button style="margin-right: 10px;" type="primary" @click="importBody">
      导入核注表体
    </el-button>
    <el-button
      style="margin-right: 10px;"
      type="primary"
      @click="confirmImport"
    >
      确认导入
    </el-button>
    <input
      id="upFile"
      type="file"
      style="display: none"
      accept=".xlsx, .xls"
      @change="upChange"
    />
    <el-tabs type="card" style="margin-top: 20px;">
      <el-tab-pane label="表体">
        <element-table
          :maxHeight="550"
          :data="bodyList"
          :columns="bodyColumns"
          border
        ></element-table>
      </el-tab-pane>
      <el-tab-pane label="保税电商清单">
        <div style="width: 300px">
          <element-table
            :maxHeight="550"
            :data="billIds"
            :columns="billColumns"
            border
          ></element-table>
        </div>
      </el-tab-pane>
    </el-tabs>
  </el-dialog>
</template>
<script>
import * as XLSX from "xlsx";
import ElementTable from "@/components/ElementTable";
export default {
  components: {
    ElementTable,
  },
  props: {
    visible: {
      type: Boolean,
    },
  },
  watch: {
    visible(val) {
      if (!val) {
        this.bodyList = [];
        this.billIds = [];
      }
    },
  },
  data() {
    return {
      bodyList: [],
      billIds: [],
      billColumns: [
        {
          title: "序号",
          key: "index",
          align: "center",
          type: "index",
        },
        {
          title: "清单号",
          key: "billNo",
          align: "center",
        },
      ],
      bodyColumns: [
        {
          title: "序号",
          key: "listGNo",
          align: "center",
        },
        {
          title: "备案序号",
          key: "gno",
          align: "center",
        },
        {
          title: "商品料号",
          key: "copGNo",
          align: "center",
        },
        {
          title: "报关单商品序号",
          key: "entGno",
          align: "center",
        },
        {
          title: "商品编码",
          key: "codeTs",
          align: "center",
        },
        {
          title: "商品名称",
          key: "gname",
          align: "center",
        },
        {
          title: "规格型号",
          key: "gModel",
          align: "center",
        },
        {
          title: "币制",
          key: "currency",
          align: "center",
        },
        {
          title: "申报计量单位",
          key: "unit",
          align: "center",
        },
        {
          title: "法定计量单位",
          key: "unit1",
          align: "center",
        },
        {
          title: "法定第二计量单位",
          key: "unit2",
          align: "center",
        },
        {
          title: "申报数量",
          key: "qty",
          align: "center",
        },
        {
          title: "法定数量",
          key: "factor1",
          align: "center",
        },
        {
          title: "法二数量",
          key: "factor2",
          align: "center",
        },
        {
          title: "申报单价",
          key: "decPrice",
          align: "center",
        },
        {
          title: "申报总价",
          key: "decTotal",
          align: "center",
        },
        {
          title: "原产国",
          key: "countryCode",
          align: "center",
        },
        {
          title: "毛重",
          key: "grossWeight",
          align: "center",
        },
        {
          title: "净重",
          key: "netWeight",
          align: "center",
        },
      ],
    };
  },
  methods: {
    importBody() {
      document.getElementById("upFile").click();
    },
    upChange(e) {
      const file = e.target.files[0];
      const reader = new FileReader();
      reader.onload = (event) => {
        const data = new Uint8Array(event.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName1 = workbook.SheetNames[0];
        const sheetName2 = workbook.SheetNames[1];
        const worksheet = workbook.Sheets[sheetName1];
        const worksheet2 = workbook.Sheets[sheetName2];
        const json1 = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        const json2 = XLSX.utils.sheet_to_json(worksheet2, { header: 1 });
        if (json1.length === 0 || json1.length === 1) {
          this.$message.error("表体数据不能为空");
          return;
        }
        if (json2.length === 0 || json2.length === 1) {
          this.$message.error("清单号数据不能为空");
          return;
        }
        this.bodyList = json1.slice(1).map((item, index) => ({
          listGNo: item[0],
          gno: item[1],
          copGNo: item[2],
          entGno: item[3],
          codeTs: item[5],
          gname: item[6],
          gModel: item[7],
          currency: item[8],
          unit: item[9],
          unit1: item[10],
          unit2: item[11],
          qty: item[12],
          factor1: item[13],
          factor2: item[14],
          decPrice: item[15],
          decTotal: item[16],
          countryCode: item[17],
          grossWeight: item[22],
          netWeight: item[23],
        }));
        this.billIds = json2.slice(1).map((item, index) => ({
          billNo: item[0],
        }));

        e.target.value = "";
      };
      reader.readAsArrayBuffer(file);
    },
    confirmImport() {
      const data = {
        billNoList: this.billIds.map((item) => item.billNo),
        bodyList: this.bodyList,
      };
      this.$emit("confirmImport", data);
    },
    handleClose() {
      this.$emit("close");
    },
  },
};
</script>
